import ButtonBack from "../ButtonBack";
import "./style.css";

export default function CaptureButtonPanel({
  onCaptureClick,
  disabled,
  backDisabled,
  text,
}) {
  return (
    <div className="capture-button-panel">
      {backDisabled ? <div /> : <ButtonBack />}
      <button
        className={`btn ${disabled ? "gray" : "blue"}`}
        onClick={() => typeof onCaptureClick === "function" && onCaptureClick()}
        disabled={disabled}
      >
        {text}
      </button>
      <div></div>
    </div>
  );
}
